import TabPanels from '@rsa-digital/evo-shared-components/components/TabPanels';
import { graphql } from 'gatsby';
import React from 'react';

type ContentTabsBlockProps = {
  tab_panel: {
    label: string;
    panel_content: string;
  }[];
  show_coloured_background: boolean;
  html_id?: string;
};

export const query = graphql`
  fragment ContentTabsBlock on cs__content_tabs {
    html_id
    show_coloured_background
    tab_panel {
      label
      panel_content
    }
  }
`;

// Refactoring for the future: Set componentProps for TabPanels in SCL and tie the id directly to the component
const ContentTabsBlock: React.FC<{
  content_tabs: ContentTabsBlockProps;
}> = ({ content_tabs }) => (
  <div id={content_tabs.html_id}>
    <TabPanels
      showColouredBackground={content_tabs.show_coloured_background}
      tabPanels={content_tabs.tab_panel.map((panel) => ({
        label: panel.label,
        panelContent: panel.panel_content,
      }))}
    />
  </div>
);

export default React.memo(ContentTabsBlock);
